module.exports = __webpack_public_path__ + "img/sao-mateus.09543aae.png";